import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Form from 'react-bootstrap/Form';
import AppInput from 'shared/AppInput';

import { useFormikContext } from 'formik';

import { GATEWAY_ID_TYPES_PROP } from 'utils/shape-props';

const propTypes = {
  // No props needed as the component uses useFormikContext
  idTypes: GATEWAY_ID_TYPES_PROP.isRequired,
}

const defaultProps = {

}

const AsoExpressForm = ({ idTypes }) => {
  const { values, errors, handleChange, setFieldValue } = useFormikContext();

  const handleTokenChange = (e) => {
    const rawValue = e.target.value.replace(/\s+/g, '');
    const formattedValue = formatToken(rawValue);
    
    e.target.value = formattedValue;
    
    setFieldValue('token', rawValue);
  };

  return (
    <div>
      {/* Currently using only 1 kind of ID, set on default values for the form */}
      {/* <Form.Group>
        <Form.Label className="font-weight-bold">Tipo de Cédula</Form.Label>
        <Form.Control 
          onChange={ handleChange } 
          name="id_type"  
          className="gateway-dropdown" 
          as="select" 
          custom
        >
          { idTypes.map( (option, index) => 
            <option key={ option.value } value={ option.value }>{ option.label }</option>
          )}
        </Form.Control>
      </Form.Group> */}
  
      <AppInput 
        label="Número de Cédula" 
        name="client_id" 
        labelClassName="font-weight-bold"
        value={ values.client_id } 
        onChange={ handleChange }
        placeholder="123456789" 
        autoComplete="off"
        error={ errors && errors.client_id }
      />
      <Form.Text className='mb16' muted>
        Debe ser la cédula del titular de la cuenta.
      </Form.Text>

      <AppInput
        label="Token"
        name="token"
        autoComplete="off"
        labelClassName="font-weight-bold"
        value={formatToken(values.token)}
        maxLength={14}
        onChange={handleTokenChange}
        placeholder="XXXX XXXX XXXX"
        error={errors && errors.token}
      />
    </div>
  )
};

/**
 * Formats a token string into blocks of 4 characters separated by double spaces
 * Example: "TY45HN23LKWQ" -> "TY45 HN23 LKWQ"
 * @param {string} value - The raw token value
 * @returns {string} - The formatted token value
 */
export const formatToken = (value = "") => {
  if (!value) {
    return value;
  }
  
  // Remove any existing spaces
  const sanitizedValue = value.replace(/\s+/g, '');
  
  // Split into chunks of 4 characters and join with double spaces
  const chunks = [];
  for (let i = 0; i < sanitizedValue.length; i += 4) {
    chunks.push(sanitizedValue.slice(i, i + 4));
  }
  
  return chunks.join(' '); // 1 space for better visibility
};

AsoExpressForm.propTypes = propTypes;
AsoExpressForm.defaultProps = defaultProps;

export default AsoExpressForm;